let state = {
  transactions: undefined,
  totalTxnCount: 0,
  csv: '',
  allTransactions: undefined
}
export default state



// WEBPACK FOOTER //
// ./src/store/transactions/state.js